import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as headerActionCreators from '../../../actions/header';
import * as videosActionCreators from '../../../actions/videos';
let allActionCreators = Object.assign({}, headerActionCreators, videosActionCreators);

import RhinoLoading from '../common/RhinoLoading';
import RhinoModal from '../../common/modal/RhinoModal';
import {VideoTileContainer} from '../videos/VideoTile';
import VideoPlayer from '../videos/VideoPlayer';

class Dashboard extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

    this.state = {
      modalOpen: false,
      modalVideo: null,
    };

    // Fetch videos list
    if(this.props.videos.videoList === null) {
      this.props.videosFetchList()
      .then((respData) => {
        this.props.videosSetList(respData.videos);
      })
      .catch((errorResp) => {
        console.error(errorResp);
      });
    }
	}

	componentWillMount() {
    let pageTitle = 'Crash of Rhinos';
    if(pageTitle !== this.props.header.headerTitle) {
      this.props.headerTitle(pageTitle);
    }
    this.props.headerBack(false);
  }

  userNav(page) {
    this.context.router.push('/' + page);
  }

  manualNav() {
    this.context.router.push('/manual');
  }

  playVideo(video) {

    console.log('click play');
    console.log(video);

    this.setState({
      modalOpen: true,
      modalVideo: video
    });
  }

  closeModal() {

    console.log('close clicked');

    this.setState({
      modalOpen: false,
      modalVideo: null
    }, () => {
      console.log(this.state);
    });
  }

	render() {
		return <div className='Dashboard'>
      <div className='welcomeMessage'>
        {this.props.user.user ? 
          <span>Welcome, {this.props.user.user.first_name}!</span> :
          <span>Welcome!</span>
        }
      </div>
      {this.props.videos.videoList === null ?
			  <RhinoLoading message='Loading Videos...' /> :
        <div>
          {this.props.videos.videoList.map(videoItem => {
            return <VideoTileContainer 
                    video={videoItem} 
                    key={videoItem.videoId}
                    playVideo={::this.playVideo} />
          })}
          <div 
            className='genericTile'
            onClick={::this.manualNav}>
            <div className='textCover'>
              <img src='/img/covers/textCover.png' />
            </div>
            <div className='textLabel'>
              <div className='textTitle'>Training Manual</div>
            </div>
          </div>
        </div>
      }
		</div>;
	}
}
export default Dashboard;

function mapStateToProps(state) {
  return {
    common: state.common,
    header: state.header,
    user: state.user,
    videos: state.videos,
  };
}

export const DashboardContainer = connect(
  mapStateToProps,
  allActionCreators
)(Dashboard);


// WEBPACK FOOTER //
// ./src/components/views/dashboard/Dashboard.jsx